import { render, staticRenderFns } from "./DHRProductionStepMenu.vue?vue&type=template&id=81470844&scoped=true&"
import script from "./DHRProductionStepMenu.vue?vue&type=script&lang=js&"
export * from "./DHRProductionStepMenu.vue?vue&type=script&lang=js&"
import style0 from "./DHRProductionStepMenu.vue?vue&type=style&index=0&id=81470844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81470844",
  null
  
)

export default component.exports